import { Container, Divider } from '@cleartrip/ct-design-components'

import { Stencil } from '@/components/common/Stencil'
import { benefitListData } from '@/constants/Srp'

export default function FareCardLoader() {
    return (
        <Container
            className={`br-16 ba-solid p-relative ml-4 flex flex-column bc-line-500`}
            style={{
                minWidth: '236px',
                borderWidth: '1px',
                // Don't stretch to a tall sibling / leftover Value Max spacer while loading.
                alignSelf: 'flex-start',
            }}
        >
            <Container
                className="br-16"
                css={{
                    background: '#ffffff',
                    position: 'relative'
                }}
            >
                <Container className="px-4 pt-4 br-16 flex flex-column">
                    <Container className="mb-3">
                        <Container className="flex flex-column flex-gap-1">
                            <Stencil shimmer height="20px" width="100px" />
                            <Stencil shimmer height="8px" width="50px" />
                        </Container>

                        <Container className="mt-3 flex flex-baseline">
                            <Stencil shimmer height="26px" width="60px" />
                        </Container>

                        <Container className="mt-7">
                            <Stencil shimmer height="40px" width="100%" />
                        </Container>
                    </Container>
                    <Container className="flex flex-column flex-end pb-2 mt-4">
                        {benefitListData.map((benefit, index) => {
                            const showDivider = index < benefitListData.length - 1
                            return (
                                <Container key={index} className="flex flex-column" css={{ height: '40px' }}>
                                    <Container css={{ paddingBottom: '13px', paddingTop: '12px' }}>
                                        <Stencil shimmer height="15px" width="100%" />
                                    </Container>
                                    {showDivider && <Divider borderColor="#E6E6E6" borderStyle="dashed" />}
                                </Container>
                            )
                        })}
                    </Container>
                </Container>
            </Container>
        </Container>
    )
}
